import ReactDOM from 'react-dom/client';
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Components/Layout";
import Home from "./Home";
import About from "./About";
import BoardGovernors from "./BoardGovernors";
import News from "./News";
import Downloads from "./Downloads";
import Careers from "./Careers";
import Contact from "./Contact";
import Application from "./Application";
import NotFound from './NotFound';
import ScrollToTop from "./Components/ScrollToTop";

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
     <BrowserRouter>
     <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home/>} />
          <Route path="about" element={<About/>} />
          <Route path="bog" element={<BoardGovernors/>} />
          <Route path="news" element={<News/>} />
          <Route path="downloads" element={<Downloads/>} />
          <Route path="career" element={<Careers/>} />
          <Route path="contact" element={<Contact/>} />
          <Route path="application" element={<Application/>} />
          <Route path="*" element={<NotFound />} />
        </Route>
        
        
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

